const search = (students, nameInput, tagInput) => {
  let lowercaseNameInput = nameInput.toString().toLowerCase();
  let lowercaseTagInput = tagInput.toString().toLowerCase();
  let searchResults;
  
  if (!(students instanceof Array)) return alert("students list must be an array");
  //when none of the fields has been entered
  if (!nameInput && !tagInput) return students;
  //name field has been entered
  if (nameInput) {
    searchResults = [
      ...students.filter(({ firstName, lastName }) =>
        (firstName + " " + lastName).toLowerCase().includes(lowercaseNameInput)
      ),
    ];
    //when tag field has been entered before the name field
    if (tagInput) {
      searchResults = [
        ...searchResults.filter(({ tags }) => {
          return tags.find((tag) =>
            tag.toLowerCase().includes(lowercaseTagInput)
          );
        }),
      ];
      return searchResults;
    } else {
      //returns results from name search if tag field was not entered before name
      return searchResults;
    }
  } else {
    //if name field is empty, search by tag only
    if (tagInput) {
      searchResults = [
        ...students.filter(({ tags }) => {
          return tags.find((tag) =>
            tag.toLowerCase().includes(lowercaseTagInput)
          );
        }),
      ];
      return searchResults;
    }
  }
};
export default search;
